import { CepService } from './../../../services/cep/cep.service';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import {
  AuthenticationService,
  IBGEService,
  SiteService
} from 'src/app/services';
import { ICidade, IEquipamento, IEstado, ISite } from 'src/app/interfaces';
import { NovoSuprimentoFormProvider } from 'src/app/providers';
import { IToken } from 'src/app/interfaces/token/IToken';

@Component({
  selector: 'app-novo-suprimento-b',
  templateUrl: './novo-suprimento-b.component.html',
  styleUrls: ['./novo-suprimento-b.component.scss']
})
export class NovoSuprimentoBComponent implements OnInit, OnDestroy {
  subscriptions$ = new Subscription();
  equipamento: IEquipamento;
  endereco: ISite;
  form!: FormGroup;
  estados: IEstado[] = [];
  cidades: ICidade[] = [];
  token: IToken;

  constructor(
    private router: Router,
    private IBGEService: IBGEService,
    private cepService: CepService,
    private siteService: SiteService,
    private location: Location,
    private novoSuprimentoFormProvider: NovoSuprimentoFormProvider,
    private authenticationService: AuthenticationService
  ) {}
  populaForm(
    dados: Partial<{
      nome: string;
      codigo: string;
      endereco: string;
      logradouro: string;
      numero: number;
      bairro: string;
      cidade: string;
      estado: string;
      cep: string;
      complemento: string;
    }>
  ) {
    this.form.patchValue(dados);
  }

  alternaForm(acao: 'enable' | 'disable' = 'enable') {
    this.form.get('cep')?.[acao]();
    this.form.get('logradouro')?.[acao]();
    this.form.get('numero')?.[acao]();
    this.form.get('estado')?.[acao]();
    this.form.get('cidade')?.[acao]();
    this.form.get('complemento')?.[acao]();
  }

  getAddressByCep(valor: string) {
    this.cepService
      .getAddresByCep(valor)
      .subscribe(({ logradouro, localidade: cidade, uf: estado, bairro }) =>
        this.populaForm({
          logradouro,
          cidade,
          estado,
          bairro
        })
      );
  }

  getUserAdress() {
    if (!this.equipamento.codSite) {
      return;
    }

    this.subscriptions$.add(
      this.siteService
        .getSite({
          codSite: this.equipamento.codSite,
          tipoUsuario: this.token.tipoUsuario,
          codContrato: this.token.codContrato,
          codGrupoEconomico: this.token.codGrupoEconomico
        })
        .subscribe({
          next: ({
            data: {
              registros: [site]
            }
          }) => {
            this.endereco = site;
          }
        })
    );
  }

  getState() {
    this.subscriptions$.add(
      this.IBGEService.getEstados().subscribe({
        next: (response) => {
          this.estados = response;
        }
      })
    );
  }

  getCities(state: string) {
    this.subscriptions$.add(
      this.IBGEService.getCidadesPorEstado(state).subscribe({
        next: (response) => {
          this.cidades = response;
        }
      })
    );
  }

  prosseguir(): void {
    this.router.navigateByUrl('/novo-suprimento/abrir-chamado/3');
  }

  ngOnInit() {
    this.token = this.authenticationService.obterToken();
    const primeiroPassoInvalido = this.novoSuprimentoFormProvider
      .getForm()
      .get('primeiroPasso')?.valid;
    if (!primeiroPassoInvalido) {
      this.location.back();
      return;
    }

    this.equipamento = this.novoSuprimentoFormProvider
      .getForm()
      .get('equipamento')?.value;
    this.form = this.novoSuprimentoFormProvider
      .getForm()
      .get('segundoPasso') as FormGroup;
    this.subscriptions$.add(
      this.form.get('usarEnderecoEquipamento')?.valueChanges.subscribe({
        next: (value) => {
          if (value) {
            this.populaForm({
              ...this.endereco,
              numero: this.endereco.numero,
              complemento: this.endereco.complemento
            });
            this.alternaForm('disable');
            return;
          }

          this.alternaForm();
        }
      })
    );
    this.subscriptions$.add(
      this.form.get('cep')?.valueChanges.subscribe({
        next: (value) => {
          if (value.length === 8) {
            this.getAddressByCep(value);
          }
        }
      })
    );
    this.subscriptions$.add(
      this.form.get('estado')?.valueChanges.subscribe({
        next: (value) => {
          this.getCities(value);
        }
      })
    );
    this.getUserAdress();
    this.getState();
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
